// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k0uc","col":"styles_col__3BFRv","actions":"styles_actions__2bug-","conflict":"styles_conflict__3P7v2"};